const Airwallex = {
  jobTitle: "Software Engineer II",
  company: "Airwallex",
  duration: "Mar 2025 - Present",
  description: "Working as a Software Engineer in the Growth team",
  jobscope: ["Working as a Software Engineer in the Growth team"],
  funFact:
    "My first day coincided with the opening of the new office! Got to experience an exciting lion dance and a donut buffet!",
};

export default Airwallex;
